import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import { Heading, Tag, useDeviceContext } from '@spotahome/ui-library';

import ListingSocialButtons from '@spotahome/marketplace-common/src/components/ListingSocialButtons';

import PropertyDescriptionItem from './PropertyDescriptionItem';

import './SimplifiedPropertyTitle.scss';

const SimplifiedPropertyTitle = ({
  className = '',
  title,
  type,
  details,
  listingId = null,
  showSocialButtons = true,
  isChecked = false
}) => {
  const { deviceOS } = useDeviceContext();
  const getPropertyType = () =>
    type === 'room_shared_apt' ? 'flatmates' : 'bedrooms';

  const isListingSimplificationHeaderVariant =
    useSoyuzExperiment('ListingSimplificationHeader').get('behaviour') ===
    'variant';

  const headingClasses = classNames('simplified-property-title__heading', {
    'simplified-property-title__heading--variant':
      isListingSimplificationHeaderVariant
  });
  const detailsClasses = classNames('simplified-property-title__details', {
    'simplified-property-title__details--variant':
      isListingSimplificationHeaderVariant
  });

  return (
    <div className={classNames('simplified-property-title', className)}>
      <div className="simplified-property-title__content">
        {isChecked && (
          <Tag
            size="small"
            colorSchema="tag"
            label={trans('listing.labels.checked.title').toUpperCase()}
          />
        )}
        <Heading
          level={1}
          theme="dark"
          size="large"
          align="left"
          className={headingClasses}
          text={title}
          inline
          type="none"
        />
        <div className={detailsClasses}>
          <span>{trans(`listing.type.${type}`)}</span>
          <PropertyDescriptionItem
            value={details.nBedrooms}
            text={trans(`listing.property-title-section.${getPropertyType()}`, {
              n: details.nBedrooms
            })}
          />
          <PropertyDescriptionItem
            value={details.nBathrooms}
            text={trans('listing.property-title-section.bathrooms', {
              n: details.nBathrooms
            })}
          />
          {details.m2 > 0 && (
            <PropertyDescriptionItem value={details.m2} text="m2" />
          )}
        </div>
      </div>
      {isListingSimplificationHeaderVariant && showSocialButtons && (
        <ListingSocialButtons
          listingId={listingId}
          isRedesign
          deviceOS={deviceOS}
        />
      )}
    </div>
  );
};

SimplifiedPropertyTitle.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  details: PropTypes.shape({
    nBedrooms: PropTypes.number,
    nBathrooms: PropTypes.number,
    m2: PropTypes.number
  }).isRequired,
  listingId: PropTypes.string,
  showSocialButtons: PropTypes.bool,
  isChecked: PropTypes.bool
};

export default SimplifiedPropertyTitle;
